// Translations
import form from '../sections/form/translations/tr'

// Translation: Verification > Landing (Turkish)
export default Object.freeze({
	sections: { form }
})
